<template>
  <div>
    <a-row>
      <a-card>
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  :beforeSend="master.beforeSend"
                  ref="master"
                  modalWidth="80%"
                  @action="masterAction"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha del voluntariado')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['fecha_volunteering', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Tipo de voluntariado')"
                            :formItemConfig="fiOptions"
                            :decorator="['type_volunteering', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                            :params="tipoVoluntariado">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha de retiro')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['fecha_retiro', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['status_volunt', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-card>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipoVoluntariado: {h_lookup_type: 'TYPE_VOLUNTEERING', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'volunteering',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_volunteering'
            },
            columns: [
              {title: 'ID Voluntariado', dataIndex: 'id_volunteering', sorter: true},
              {title: 'Fecha del voluntariado', dataIndex: 'fecha_volunteering_desc', sorter: true},
              {title: 'Tipo de voluntariado', dataIndex: 'destypevolunteering', sorter: true},
              {title: 'Fecha de retiro', dataIndex: 'fecha_retiro_desc', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'fecha_volunteering'},
            {name: 'type_volunteering'},
            {name: 'fecha_retiro'},
            {name: 'status_volunt', type: 'boolean'}
          ]
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (action.record.status_volunt === 'S') {
              this.$refs.master.modal.form.setFieldsValue({
                status_volunt: true
              })
            } else {
              this.$refs.master.modal.form.setFieldsValue({
                status_volunt: false
              })
            }
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/VoluntariadoSST.vue